import { EventEmitter } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { IVideoOverlay } from './IVideoOverlay';
import { VideoOverlay } from './VideoOverlay';

export class VideoOverlayManager {
	private videoOverlays: IVideoOverlay[];
	private activeOverlaysSubject$: BehaviorSubject<VideoOverlay[]> = new BehaviorSubject<VideoOverlay[]>([]);

	public activeOverlays$: Observable<VideoOverlay[]> = this.activeOverlaysSubject$.asObservable();

	constructor(
		private parentElement: HTMLElement,
		private onOverlayAdded: EventEmitter<IVideoOverlay>,
		private onOverlayRemoved: EventEmitter<IVideoOverlay>
	) {}

	public loadOverlays(videoOverlays: IVideoOverlay[]): void {
		this.videoOverlays = [...(videoOverlays || [])];
		this.manageOverlaysDisplay();
	}

	public cleanupOverlays(): void {
		this.activeOverlays?.forEach(overlay => overlay.destroyOverlay());
		this.addOverlays([]);
	}

	private manageOverlaysDisplay(): void {
		this.destroyOverlays();
		this.constructOverlays();
	}

	private constructOverlays(): void {
		this.videoOverlays?.forEach(overlay => {
			if (!this.activeOverlays?.find(ov => ov.id === overlay.id)) {
				overlay.cssClasses = ['basicOverlay', ...(overlay.cssClasses || [])];

				const nOverlay = new VideoOverlay(overlay, this.parentElement);
				nOverlay.constructOverlay();

				this.addOverlay(nOverlay);
				this.onOverlayAdded.emit(overlay);
			}
		});
	}

	private destroyOverlays(): void {
		const removedOverlayIds = [];

		this.activeOverlays?.forEach(overlay => {
			if (!this.videoOverlays?.find(ov => ov.id === overlay.id)) {
				overlay.destroyOverlay();
				removedOverlayIds.push(overlay.id);
				this.onOverlayRemoved.emit(overlay);
			}
		});

		if (removedOverlayIds?.length) {
			this.addOverlays(this.activeOverlays.filter(ov => removedOverlayIds.find(i => i !== ov.id)));
		}
	}

	private get activeOverlays(): VideoOverlay[] {
		return this.activeOverlaysSubject$.value;
	}

	private addOverlay(newOverlay: VideoOverlay): void {
		const overlays = [...this.activeOverlays, newOverlay];
		this.activeOverlaysSubject$.next(overlays);
	}

	private addOverlays(overlays: VideoOverlay[]): void {
		this.activeOverlaysSubject$.next([...overlays]);
	}

}
